import type { ReactNode } from 'react';

export const symbol_digital_wellbeing: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M385-651q-39-39-39-95t39-95q39-39 95-39t95 39q39 39 39 95t-39 95q-39 39-95 39t-95-39Zm148.5-41.5Q554-713 554-746t-20.5-53.5Q513-820 480-820t-53.5 20.5Q406-779 406-746t20.5 53.5Q447-672 480-672t53.5-20.5ZM438-122 240-320q-18-18-29-44.5T200-426q0-56 39.5-95.5T335-561q26 0 48.5 12t39.5 29l57 57 57-57q17-17 39.5-29t48.5-12q56 0 95.5 39.5T760-426q0 35-11 61.5T720-320L522-122q-9 9-20 13t-22 4q-11 0-22-4t-20-13Zm42-45 196-196q12-12 18-27t6-36q0-30-22.5-52.5T625-501q-14 0-26 5t-20 13l-99 99-99-99q-8-8-20-13t-26-5q-30 0-52.5 22.5T260-426q0 21 6 36t18 27l196 196Zm0-579Zm0 412Z"
		/>
	</svg>
);
